import type {
  QuestionListItem,
  QuestionDetail,
  QuestionUpsertRequest,
  QuestionTypeOption,
  InputFormatOption,
} from '../types';
import { apiFetch } from '../../../../common/api/apiFetchClient';

const BASE = '/api/rfi/questions';

export const questionsApi = {
  listQuestions(surveyId?: number): Promise<{ questions: QuestionListItem[] }> {
    const qs = surveyId !== undefined ? `?surveyId=${surveyId}` : '';
    return apiFetch(`${BASE}${qs}`);
  },

  getQuestion(questionId: number): Promise<{ question: QuestionDetail }> {
    return apiFetch(`${BASE}/${questionId}`);
  },

  createQuestion(body: QuestionUpsertRequest): Promise<{ questionId: number }> {
    return apiFetch(`${BASE}`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  updateQuestion(questionId: number, body: QuestionUpsertRequest): Promise<{ questionId: number }> {
    return apiFetch(`${BASE}/${questionId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },

  archiveQuestion(questionId: number): Promise<{ questionId: number }> {
    return apiFetch(`${BASE}/${questionId}/archive`, { method: 'POST' });
  },

  listQuestionTypes(): Promise<{ questionTypes: QuestionTypeOption[] }> {
    return apiFetch(`${BASE}/types`);
  },

  listInputFormats(): Promise<{ inputFormats: InputFormatOption[] }> {
    return apiFetch(`${BASE}/input-formats`);
  },
};
